/** Fetches a template's full story JSON from its contentPointer, rejecting error responses. */
export const fetchTemplateStory = async (
  contentPointer: string,
): Promise<Record<string, unknown>> => {
  const response = await fetch(contentPointer);
  if (!response.ok) {
    throw new Error(`Template fetch failed: ${response.status}`);
  }
  return (await response.json()) as Record<string, unknown>;
};
